import axios from 'axios'
import React, { useState } from 'react'

const ADMIN_URL = 'admin'

const FacultyForgotPassword = () => {
    const [email, setEmail] = useState('')
    const [link, setLink] = useState('')
    const [submitted, setSubmitted] = useState(false)
    const token = localStorage.getItem('token')
    const handleSubmit = (e) => {
        e.preventDefault()
        let data = { email }
        axios.post(`${process.env.REACT_APP_DEPT_API}/${ADMIN_URL}/auth/faculty/forgot-password`, data, {
            headers: {
                authorization: `Bearer ${token}`
            }
        }).then(res => {
            if (res.data && res.data.error) {
                setEmail('')
                alert(res.data.error)
                return
            }
            setLink(res.data.link)
            setSubmitted(true)
        }).catch(err => {
            alert(err.message)
            console.log(err)
            setSubmitted(false)
        })
    }
    return (
        <div className='admin'>
            <div className='section__container'>
                <div className='section'>
                    <h3 className='section__header'>Reset Password for Faculty</h3>
                    <form onSubmit={handleSubmit} className="admin_form_container">
                        <div className='admin_input_container'>
                            <label className='admin_label'>Enter registered email of Faculty</label>
                            <input className='admin_input' value={email} required type="email" onChange={(e) => setEmail(e.target.value)} placeholder="johndoe@email.com" />
                        </div>
                        <button type="submit" className='admin_btn' disabled={submitted}>Submit</button>
                    </form>
                    {submitted &&
                        <div >
                            <h3> Use this link to reset password [Valid for 15 minutes]</h3>
                            <div>
                                <a href={link} >{link}</a>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default FacultyForgotPassword